export enum UserSystemRoleModelPermissionMap {
  'global-allow-any' = 'global-allow-any',
  'is-have-access-to-projects' = 'is-have-access-to-projects',
  'project-can-create' = 'project-can-create',
  'project-in-team-delete' = 'project-in-team-delete',
  'project-in-team-update' = 'project-in-team-update',
  'project-in-team-read' = 'project-in-team-read',
  'project-not-in-team-access' = 'project-not-in-team-access',
  'project-not-in-team-permission-create-project' = 'project-not-in-team-permission-create-project',
  'project-not-in-team-permission-update-team-project' = 'project-not-in-team-permission-update-team-project',
  'project-not-in-team-permission-update-fields-project' = 'project-not-in-team-permission-update-fields-project',
  'project-not-in-team-permission-update-project' = 'project-not-in-team-permission-update-project',
  'project-not-in-team-permission-delete-project' = 'project-not-in-team-permission-delete-project',
  'project-not-in-team-permission-create-application' = 'project-not-in-team-permission-create-application',
  'project-not-in-team-permission-update-application' = 'project-not-in-team-permission-update-application',
  'project-not-in-team-permission-delete-application' = 'project-not-in-team-permission-delete-application',
  'project-not-in-team-permission-report-access' = 'project-not-in-team-permission-report-access',
  'project-not-in-team-permission-custom-requirement-access' = 'project-not-in-team-permission-custom-requirement-access',
  'project-not-in-team-permission-accept-cancel-access' = 'project-not-in-team-permission-accept-cancel-access',
  'project-not-in-team-permission-show-unverified-requirements-access' = 'project-not-in-team-permission-show-unverified-requirements-access',
  'project-not-in-team-permission-show-regulators' = 'project-not-in-team-permission-show-regulators',
  'project-not-in-team-permission-new-comments-access' = 'project-not-in-team-permission-new-comments-access',
  'project-not-in-team-permission-jira-intergration' = 'project-not-in-team-permission-jira-intergration',
  'settings-is-allow' = 'settings-is-allow',
  'settings-specifications-delete' = 'settings-specifications-delete',
  'settings-specifications-create' = 'settings-specifications-create',
  'settings-specifications-update' = 'settings-specifications-update',
  'settings-specifications-read' = 'settings-specifications-read',
  'settings-requirements-delete' = 'settings-requirements-delete',
  'settings-requirements-create' = 'settings-requirements-create',
  'settings-requirements-update' = 'settings-requirements-update',
  'settings-requirements-read' = 'settings-requirements-read',
  'settings-requirements-accept' = 'settings-requirements-accept',
  'settings-requirement-vendors-delete' = 'settings-requirement-vendors-delete',
  'settings-requirement-vendors-create' = 'settings-requirement-vendors-create',
  'settings-requirement-vendors-update' = 'settings-requirement-vendors-update',
  'settings-requirement-vendors-read' = 'settings-requirement-vendors-read',
  'settings-tags-delete' = 'settings-tags-delete',
  'settings-tags-create' = 'settings-tags-create',
  'settings-tags-update' = 'settings-tags-update',
  'settings-tags-read' = 'settings-tags-read',
  'settings-statuses-delete' = 'settings-statuses-delete',
  'settings-statuses-create' = 'settings-statuses-create',
  'settings-statuses-update' = 'settings-statuses-update',
  'settings-statuses-read' = 'settings-statuses-read',
  'settings-performers-delete' = 'settings-performers-delete',
  'settings-performers-create' = 'settings-performers-create',
  'settings-performers-update' = 'settings-performers-update',
  'settings-performers-read' = 'settings-performers-read',
  'settings-additional-columns-delete' = 'settings-additional-columns-delete',
  'settings-additional-columns-create' = 'settings-additional-columns-create',
  'settings-additional-columns-update' = 'settings-additional-columns-update',
  'settings-additional-columns-read' = 'settings-additional-columns-read',
  'settings-integrations-delete' = 'settings-integrations-delete',
  'settings-integrations-create' = 'settings-integrations-create',
  'settings-integrations-update' = 'settings-integrations-update',
  'settings-integrations-read' = 'settings-integrations-read',
  'settings-application-template-delete' = 'settings-application-template-delete',
  'settings-application-template-create' = 'settings-application-template-create',
  'settings-application-template-update' = 'settings-application-template-update',
  'settings-application-template-read' = 'settings-application-template-read',
  'settings-user-entity-delete' = 'settings-user-entity-delete',
  'settings-user-entity-create' = 'settings-user-entity-create',
  'settings-user-entity-update' = 'settings-user-entity-update',
  'settings-user-entity-read' = 'settings-user-entity-read',
  'settings-user-project-role-delete' = 'settings-user-project-role-delete',
  'settings-user-project-role-create' = 'settings-user-project-role-create',
  'settings-user-project-role-update' = 'settings-user-project-role-update',
  'settings-user-project-role-read' = 'settings-user-project-role-read',
  'settings-user-system-role-delete' = 'settings-user-system-role-delete',
  'settings-user-system-role-create' = 'settings-user-system-role-create',
  'settings-user-system-role-update' = 'settings-user-system-role-update',
  'settings-user-system-role-read' = 'settings-user-system-role-read',
  'settings-user-system-role-application-transfer' = 'settings-user-system-role-application-transfer',
}

export const SupportedUserSystemRolePermissions: UserSystemRoleModelPermissionMap[] = [
  UserSystemRoleModelPermissionMap['global-allow-any'],
  UserSystemRoleModelPermissionMap['is-have-access-to-projects'],
  UserSystemRoleModelPermissionMap['project-in-team-read'],
  UserSystemRoleModelPermissionMap['project-not-in-team-access'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-create-project'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-update-team-project'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-update-fields-project'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-update-project'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-delete-project'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-create-application'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-update-application'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-delete-application'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-report-access'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-custom-requirement-access'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-accept-cancel-access'],
  UserSystemRoleModelPermissionMap['project-not-in-team-permission-new-comments-access'],
  UserSystemRoleModelPermissionMap['settings-is-allow'],
  UserSystemRoleModelPermissionMap['settings-specifications-delete'],
  UserSystemRoleModelPermissionMap['settings-specifications-create'],
  UserSystemRoleModelPermissionMap['settings-specifications-update'],
  UserSystemRoleModelPermissionMap['settings-specifications-read'],
  UserSystemRoleModelPermissionMap['settings-requirements-delete'],
  UserSystemRoleModelPermissionMap['settings-requirements-create'],
  UserSystemRoleModelPermissionMap['settings-requirements-update'],
  UserSystemRoleModelPermissionMap['settings-requirements-read'],
  UserSystemRoleModelPermissionMap['settings-requirement-vendors-delete'],
  UserSystemRoleModelPermissionMap['settings-requirement-vendors-create'],
  UserSystemRoleModelPermissionMap['settings-requirement-vendors-update'],
  UserSystemRoleModelPermissionMap['settings-requirement-vendors-read'],
  UserSystemRoleModelPermissionMap['settings-tags-delete'],
  UserSystemRoleModelPermissionMap['settings-tags-create'],
  UserSystemRoleModelPermissionMap['settings-tags-update'],
  UserSystemRoleModelPermissionMap['settings-tags-read'],
  UserSystemRoleModelPermissionMap['settings-statuses-delete'],
  UserSystemRoleModelPermissionMap['settings-statuses-create'],
  UserSystemRoleModelPermissionMap['settings-statuses-update'],
  UserSystemRoleModelPermissionMap['settings-statuses-read'],
  UserSystemRoleModelPermissionMap['settings-performers-delete'],
  UserSystemRoleModelPermissionMap['settings-performers-create'],
  UserSystemRoleModelPermissionMap['settings-performers-update'],
  UserSystemRoleModelPermissionMap['settings-performers-read'],
  UserSystemRoleModelPermissionMap['settings-additional-columns-delete'],
  UserSystemRoleModelPermissionMap['settings-additional-columns-create'],
  UserSystemRoleModelPermissionMap['settings-additional-columns-update'],
  UserSystemRoleModelPermissionMap['settings-additional-columns-read'],
  UserSystemRoleModelPermissionMap['settings-integrations-delete'],
  UserSystemRoleModelPermissionMap['settings-integrations-create'],
  UserSystemRoleModelPermissionMap['settings-integrations-update'],
  UserSystemRoleModelPermissionMap['settings-integrations-read'],
  UserSystemRoleModelPermissionMap['settings-application-template-delete'],
  UserSystemRoleModelPermissionMap['settings-application-template-create'],
  UserSystemRoleModelPermissionMap['settings-application-template-update'],
  UserSystemRoleModelPermissionMap['settings-application-template-read'],
  UserSystemRoleModelPermissionMap['settings-user-entity-delete'],
  UserSystemRoleModelPermissionMap['settings-user-entity-create'],
  UserSystemRoleModelPermissionMap['settings-user-entity-update'],
  UserSystemRoleModelPermissionMap['settings-user-entity-read'],
  UserSystemRoleModelPermissionMap['settings-user-project-role-delete'],
  UserSystemRoleModelPermissionMap['settings-user-project-role-create'],
  UserSystemRoleModelPermissionMap['settings-user-project-role-update'],
  UserSystemRoleModelPermissionMap['settings-user-project-role-read'],
  UserSystemRoleModelPermissionMap['settings-user-system-role-delete'],
  UserSystemRoleModelPermissionMap['settings-user-system-role-create'],
  UserSystemRoleModelPermissionMap['settings-user-system-role-update'],
  UserSystemRoleModelPermissionMap['settings-user-system-role-read'],
];

const SupportedUserSystemRolePermissionsSet = new Set<string>(SupportedUserSystemRolePermissions);

export const isSupportedUserSystemRolePermission = (
  permission: string,
): boolean => SupportedUserSystemRolePermissionsSet.has(permission);
